import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useState } from 'react';
import {
  FaTachometerAlt, FaUsers, FaCoins, FaUserShield, FaBullhorn,
  FaCogs, FaChevronDown, FaGift, FaCubes, FaImages, FaSignOutAlt,
  FaMapMarkerAlt, FaSlidersH, FaListOl, FaMobileAlt,
} from 'react-icons/fa';
import { logout } from '../services/authService';

const NAV = [
  { to: '/dashboard', label: 'Dashboard', icon: <FaTachometerAlt /> },
  { to: '/users', label: 'Users', icon: <FaUsers /> },
  { to: '/orders', label: 'Orders', icon: <FaCubes /> },
  { to: '/coins-history', label: 'Points History', icon: <FaCoins /> },
  { to: '/internal-users', label: 'Internal Users', icon: <FaUserShield /> },
  { to: '/promotions', label: 'Promotions', icon: <FaBullhorn /> },
  { to: '/coupons', label: 'Coupons', icon: <FaGift /> },
  { to: '/banners', label: 'Banner Images', icon: <FaImages /> },
];

const SETTINGS = [
  { to: '/settings/points-rules', label: 'Points Rules', icon: <FaListOl /> },
  { to: '/settings/general', label: 'General Settings', icon: <FaSlidersH /> },
  { to: '/settings/delivery-locations', label: 'Delivery Locations', icon: <FaMapMarkerAlt /> },
  { to: '/settings/app-version', label: 'App Version', icon: <FaMobileAlt /> },
];

export default function Sidebar({ onNavigate }) {
  const location = useLocation();
  const navigate = useNavigate();
  const inSettings = location.pathname.startsWith('/settings');
  const [settingsOpen, setSettingsOpen] = useState(inSettings);

  const isActive = (to) => location.pathname === to;

  const rowBase =
    'flex items-center gap-3 rounded-lg px-3 py-2 text-sm font-medium no-underline transition-colors';
  const rowActive = 'bg-indigo-50 text-indigo-700';
  const rowIdle = 'text-slate-600 hover:bg-slate-100 hover:text-slate-900';

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <div className="flex h-full w-[260px] flex-col bg-white border-r border-slate-200">
      {/* Brand */}
      <div className="flex items-center gap-2.5 px-5 h-16 border-b border-slate-200">
        <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-indigo-600 text-white font-bold">
          M
        </div>
        <div className="leading-tight">
          <div className="text-sm font-semibold text-slate-900">Moona Admin</div>
          <div className="text-[11px] text-slate-400">Delivery Console</div>
        </div>
      </div>

      {/* Nav */}
      <nav className="flex-1 overflow-y-auto px-3 py-4">
        <p className="px-3 pb-2 text-[11px] font-semibold uppercase tracking-wider text-slate-400">
          Menu
        </p>
        <div className="flex flex-col gap-0.5">
          {NAV.map((item) => (
            <Link
              key={item.to}
              to={item.to}
              onClick={onNavigate}
              className={`${rowBase} ${isActive(item.to) ? rowActive : rowIdle}`}
            >
              <span className="text-base">{item.icon}</span>
              <span>{item.label}</span>
            </Link>
          ))}

          {/* Settings group */}
          <button
            type="button"
            onClick={() => setSettingsOpen((v) => !v)}
            className={`${rowBase} ${inSettings ? 'text-indigo-700' : rowIdle} justify-between`}
          >
            <span className="flex items-center gap-3">
              <span className="text-base"><FaCogs /></span>
              <span>Settings</span>
            </span>
            <FaChevronDown
              className={`text-xs transition-transform ${settingsOpen ? 'rotate-180' : ''}`}
            />
          </button>
          {settingsOpen && (
            <div className="ml-4 mt-0.5 flex flex-col gap-0.5 border-l border-slate-200 pl-3">
              {SETTINGS.map((item) => (
                <Link
                  key={item.to}
                  to={item.to}
                  onClick={onNavigate}
                  className={`${rowBase} ${isActive(item.to) ? rowActive : rowIdle}`}
                >
                  <span className="text-sm">{item.icon}</span>
                  <span>{item.label}</span>
                </Link>
              ))}
            </div>
          )}
        </div>
      </nav>

      {/* Sign out */}
      <div className="border-t border-slate-200 p-3">
        <button
          type="button"
          onClick={handleLogout}
          className="flex w-full items-center gap-3 rounded-lg px-3 py-2 text-sm font-medium text-slate-600 transition-colors hover:bg-red-50 hover:text-red-600"
        >
          <FaSignOutAlt className="text-base" />
          <span>Sign out</span>
        </button>
      </div>
    </div>
  );
}
